import React from "react";
import useGlobalHook from "use-global-hook";
import * as actions from "../Actions/AppActions";


const initialState = {
    status: 200,
    isLoading: false,
    userData: [],
    imageUpload: [''],
    image_urls: [],
    expand: true,
    openMenu: '',
    moduleId: '',
    notifRuntime: false,
    notifData: [],
    qiscusComment: [],
    qiscusCommentList: [],
    navData: "",
};

const AppStore = useGlobalHook(React, initialState, actions);

export default AppStore;
